<arm-layout [summaryTitle]="'PEER CONNECTIONS SUMMARY'" >
    <div header>
        <div class="search-container">
            <arm-search [searchComponent]="pconsSearchComponent"
                        [searchData]="searchData"
                        [searchTerms]="searchTerms"
                        (onSearch)="onSearch($event)">
            </arm-search>
        </div>

        <div class="action-buttons">

          <arm-action-bar (editClick)="editItem()" [disableEdit]="isUnauthorized || !isSingleSelection()"
                          (deleteClick)="removeItem()" [disableDelete]="isUnauthorized || !isSingleSelection() || isPConDeleteDisabled()"
                          (refreshClick)="refresh()"></arm-action-bar>

            <button mat-raised-button class="more-actions" [matMenuTriggerFor]="menu" color="primary">
                <span>Actions</span>
                <mat-icon>arrow_drop_down</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="syncTopology()" [disabled]="isUnauthorized">
                    <span>Sync Topology</span>
                </button>
                <button mat-menu-item [matMenuTriggerFor]="lockSubMenu" [disabled]="isUnauthorized || !isPeerConnectionSelected()">
                    <span>Lock</span>
                </button>
                <button mat-menu-item (click)="unlock()" [disabled]="isUnauthorized || !isPeerConnectionSelected() || selectedItemAdminState() === 'UNLOCKED'">
                    <span>Unlock</span>
                </button>

                <button mat-menu-item (click)="openColumnsConfiguration()">
                    <span>Table columns</span>
                </button>
            </mat-menu>

            <mat-menu #lockSubMenu="matMenu">
                <button mat-menu-item (click)="lockIncoming()"
                        [disabled]="selectedItemAdminState() === 'LOCKED_INCOMING' || isSelectedVirtualPeerConnection()">Lock incoming</button>
                <button mat-menu-item (click)="lockOutgoing()"
                        [disabled]="selectedItemAdminState() === 'LOCKED_OUTGOING'">Lock outgoing</button>
                <button mat-menu-item (click)="lock()"
                        [disabled]="selectedItemAdminState() === 'LOCKED' || isSelectedVirtualPeerConnection()">Lock</button>
            </mat-menu>
        </div>
    </div>


    <div summary>
        <pcons-summary [selection]="selection"></pcons-summary>
    </div>


    <div main>

      <arm-table [displayedColumns]="displayedColumns" (pageChanged)="pageChanged($event)"
                 (onSelection)="onSelection($event)" [data]="data.elements" [length]="length"
                 [isMultipleSelection]="isMultipleSelection"
                 [isClientSide]="false"></arm-table>
    </div>
</arm-layout>
